<template>
  <tab-layout :actionBar="true">
    <title-edit-details :details="details" slot="tabContent" class="row mx-0 show active" />
  </tab-layout>
</template>

<script>
/* Use the "slot" attribute to match the heading and content
 * to their respective fields in the ListingLayout component. */
import tabLayout from '@/components/TabLayout'
import titleEditDetails from './TitleEditDetails'

export default {
  name: 'TitleEdit',
  props: ['details'],
  components: {
    'tab-layout': tabLayout,
    'title-edit-details': titleEditDetails
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Titles/Edit/TitleEdit.vue